import { type ColumnDef } from "@tanstack/react-table"
import type { IOffer } from "@commonTypes/offer"
import { ButtonCell } from "@utils/table/columnFactories"
import { useNewOrderFunnel } from "../utils/useNewOrderFunnel"

type TChooseOffersColumnsOptions = {
  includeEnroll?: boolean
}

export const useChooseOffersListColumns = (
  options?: TChooseOffersColumnsOptions,
): ColumnDef<IOffer>[] => {
  const includeEnroll = options?.includeEnroll !== false

  const { setStep, setSelectedOffer } = useNewOrderFunnel()
  const columns: ColumnDef<IOffer>[] = [
    { accessorKey: "offer_code", header: "Offer Code" },
    {
      accessorKey: "offer_desc",
      header: "Offer Desc",
      cell: ({ row }) => (
        <span>
          {row.original.offer_desc}
          {row.original.channel_code ? ` - ${row.original.channel_code}` : ""}
        </span>
      ),
    },
    {
      id: "sign_up_bonus_reward",
      header: "Sign Up Bonus/Reward Program",
      cell: ({ row }) => {
        const { plan_promos, plan_loyalty_programs } = row.original
        if (
          (!plan_promos || plan_promos.length === 0) &&
          (!plan_loyalty_programs || plan_loyalty_programs.length === 0)
        ) {
          return <span>-</span>
        }
        return (
          <div className="tw:space-y-1">
            {plan_promos?.map((p, i) => (
              <div key={`promo-${i}`}>{p.promo_desc}</div>
            ))}
            {plan_loyalty_programs?.map((lp, i) => (
              <div key={`lp-${i}`}>{lp.loyalty_program_desc}</div>
            ))}
          </div>
        )
      },
    },
    {
      id: "rate",
      header: "Rate",
      cell: ({ row }) => {
        const o = row.original
        if (o.is_intro_subscription) {
          return (
            <span>
              Intro Period: {o.rate_friendly} for {o.intro_period_friendly}
            </span>
          )
        }
        return (
          <span>
            {o.rate_friendly} for {o.duration_friendly}
          </span>
        )
      },
    },
  ]

  if (includeEnroll) {
    columns.push({
      id: "enroll",
      cell: (props) => {
        const offer = props.row.original
        return (
          <ButtonCell
            {...props}
            variant="default"
            label="Enroll"
            onClick={() => {
              setStep("signUp")
              setSelectedOffer(offer)
            }}
          />
        )
      },
    })
  }

  return columns
}
